import { useMemo } from "react";

import { resolveWearableProfileBridgeSnapshot } from "@/lib/wearables/wearables.profileBridge";
import { useWearablesStore } from "@/state/wearables/useWearablesStore";

export function useWearableProfileBridge() {
  const identityBaseline = useWearablesStore((state) => state.identityBaseline);

  return useMemo(
    () => resolveWearableProfileBridgeSnapshot(identityBaseline),
    [identityBaseline],
  );
}
